export const indexName = "memovs_av_v1";

export const searchkitConfig = {
  connection: {
    host: './search-proxy.php' // Proxy PHP (chemin relatif)
    
  },
  search_settings: {
    // Searchkit applique "AUTO:4,8" par défaut → trop de bruit.
    // On le désactive ici ; le fuzzy n'est réactivé qu'en repli (0 résultat) via beforeSearch.
    fuzziness: "0",
    highlight_attributes: ['titre', 'ex_titre', 'ex_cote.text', 'analyse.text', 'contient', 'sujet.text', 'auteur.text', 'notes', 'emission.text', 'sous_titre', 'genre.text', 'full_text'],
    search_attributes: [
      { field: 'cote.text', weight: 5 },
      { field: 'auteur.text', weight: 4 },
      { field: 'titre', weight: 3 },
      { field: 'sous_titre', weight: 3 },
      { field: 'ex_titre', weight: 2 },
      { field: 'sujet.text', weight: 2 },
      { field: 'genre.text', weight: 2 },
      { field: 'emission.text', weight: 1.5 },
      { field: 'ex_cote.text', weight: 1 },
      { field: 'analyse.text', weight: 1 },
      { field: 'contient', weight: 1 },
      { field: 'lieu.text', weight: 1 },
      { field: 'notes', weight: 1 },
      { field: 'full_text', weight: 1 }
    ],
    result_attributes: [
      'id', 'titre', 'ex_titre', 'date', 'date_complete', 'mdate',
      'cote', 'ex_cote', 'ex_cote_s', 'fonds', 'avmat', 'collation',
      'access', 'auteur', 'auteurRole', 'docType', 'dossier', 'emission', 'urlplus', 'imagette', 'corrigeDate', 
      'analyse', 'contient', 'sujet', 'lieu', 'genre',
      'editeur', 'sponsor', 'partenaire', 'physicLoc', 'autreSupport',
      'docs.cote', 'docs.dossier', 'docs.titre', 'docs.avdId'
    ],
    // VERSION ALLÉGÉE : 8 facettes
    facet_attributes: [
      { attribute: 'docType', field: 'docType', type: 'string' },
      { attribute: 'fonds', field: 'fonds', type: 'string' },
      { attribute: 'lieu', field: 'lieu', type: 'string' },
      { attribute: 'auteur', field: 'auteur', type: 'string' },
      { attribute: 'avmat', field: 'avmat', type: 'string' },
      { attribute: 'emission', field: 'emission', type: 'string' },
      { attribute: 'access', field: 'access', type: 'string' },
      { attribute: 'date', field: 'date', type: 'numeric' }
    ],
    sorting: {
      default: { field: '_score', order: 'desc' },
      date_desc: { field: 'corrigeDate', order: 'desc' },
      date_asc: { field: 'corrigeDate', order: 'asc' },
    }
  }
};
